import {memo, useEffect, useMemo, useState} from "react";
import {Alert, Card, Col, Image, List, Row, Space, Spin, Switch, Input, Typography, Button, Tag, Select} from "antd";
import {EyeOutlined, LoadingOutlined} from "@ant-design/icons";
import useSWR from "swr";
import CourseDiagram from "../Charts/CourseDiagram";
import pluck from "../Helpers/ArrayHelper";
import CourseDrawer from "./CourseDrawer";

const { Title } = Typography;
const { Search } = Input;

const MainCourse = memo(() => {

    const {data, error} = useSWR('/course/skill_mapping');
    const {data: courses, error: courseError} = useSWR('/course/');

    const [searchKeyword, setSearchKeyword] = useState('');
    const [filterSkill, setFilterSkill] = useState([]);

    const [viewCourseId, setViewCourseId] = useState(0);

    const filteredCourses = useMemo(() => {

        if(!courses)
            return;

        let _courses = [...courses];

        if(!!searchKeyword)
            _courses = _courses.filter((course) => {
                return course.name.toLowerCase().includes(searchKeyword.toLowerCase())
            });

        if(!!filterSkill)
            filterSkill.forEach(skill => {
                _courses = _courses.filter((course) => {
                    return pluck(course.skills, 'name').includes(skill)
                });
            })

        return _courses;

    }, [courses, searchKeyword, filterSkill])

    const [isShowingGraph, setIsShowingGraph] = useState(false);

    if (error || courseError) {
        return <Row justify={'center'} style={{ marginTop: '24px' }}>
            <Col span={20}>
                <Alert
                    message="เกิดข้อผิดพลาด"
                    description={`ไม่สามารถดาวน์โหลดข้อมูลได้ กรุณาลองอีกครั้งภายหลัง : ${error || courseError}`}
                    type="error"
                    showIcon
                />
            </Col>
        </Row>
    }

    if(!data) {
        return <>
            <Row justify={'center'} style={{ marginTop: '24px' }}>
                <Col>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 72 }} spin />} />
                </Col>
            </Row>
        </>;
    }

    if(!courses) {
        return <>
            <Row justify={'center'} style={{ marginTop: '24px' }}>
                <Col>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 72 }} spin />} />
                </Col>
            </Row>
        </>;
    }

    return <>
        <Title level={2}>
            คอร์สทั้งหมด
        </Title>
        <Card>
            {isShowingGraph ? <CourseDiagram data={data} /> :
                <>
                    <Row justify={'end'} style={{ marginBottom: '24px' }}>
                        <Col span={18}>
                            <Select
                                mode="multiple"
                                allowClear
                                style={{
                                    width: '100%'
                                }}
                                placeholder="เลือกทักษะที่ต้องการ"
                                onChange={(value) => {
                                    console.log(value)
                                    setFilterSkill(value)
                                }}
                            >
                                {
                                    data.skills.map((skill) => {
                                        return <Select.Option key={skill.id} value={skill.name}>{skill.name}</Select.Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={6}>
                            <Space>
                                <Search
                                    placeholder="ชื่อคอร์ส"
                                    allowClear
                                    onChange={(e) => {
                                        setSearchKeyword(e.target.value)
                                    }}
                                />
                            </Space>
                        </Col>
                    </Row>
                    <List
                        itemLayout="vertical"
                        size="large"
                        pagination={{
                            pageSizeOptions: [5, 10, 15, 20, 25, 50],
                            defaultPageSize: 5,
                            size: 'small'
                        }}
                        style={{ marginBottom: '24px', backgroundColor: 'white', padding: '2rem' }}
                        dataSource={filteredCourses}
                        renderItem={item => (
                            <List.Item
                                key={item.id}
                                actions={[
                                    <Button
                                        onClick={ () => { setViewCourseId(item.id) } }
                                    >
                                        <EyeOutlined /> ดูรายละเอียด
                                    </Button>
                                ]}
                                style={{ backgroundColor: 'white' }}
                                extra={
                                    <Image
                                        src={`${process.env.REACT_APP_API_BASE}/course/${item.id}/image` || ''}
                                        alt="logo"
                                        fallback={'/images/fallback.jpg'}
                                        width={272}
                                        height={272}
                                    />
                                }
                            >
                                <List.Item.Meta
                                    title={<h3>คอร์ส: <a href={item.url}>{item.name}</a></h3>}
                                    description={`โดย ${item.school}`}
                                />
                                <pre style={{
                                    fontFamily: 'inherit',
                                    wordWrap: 'break-word',
                                    whiteSpace: 'pre-wrap',
                                    textOverflow: 'break-word',
                                }}>
                                    {item.short_description}
                                </pre>
                                ทักษะที่จะได้รับ: <br/>
                                {
                                    item.skills.map((skill) => {
                                        return <Tag color={filterSkill.includes(skill.name) ? 'red' : 'green'}>{skill.name}</Tag>
                                    })
                                }
                            </List.Item>
                        )}
                    />
                </>
            }
            <Row justify={'end'}>
                <Col>
                    <Switch
                        checkedChildren="กราฟ"
                        unCheckedChildren="ตาราง"
                        onChange={(checked) => {
                            setIsShowingGraph(checked)
                        }}
                    />
                </Col>
            </Row>
        </Card>

        <CourseDrawer courseId={viewCourseId} onClose={() => { setViewCourseId(0) }} visible={viewCourseId !== 0} />
    </>
})

export default MainCourse;
